import { setPermissionsValues } from '@features/permissions';

export function normalizeApiData(data) {
  return {
    id: data.id,
    name: data.name,
    permissions: setPermissionsValues(data.permissions),
  };
}
